export default __webpack_public_path__ + "static/media/1760.46efd48f.png";